module.exports = __webpack_public_path__ + "img/fotos_pic_mobile.205459c3.jpg";